import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import { Base } from '../Base/Base.js';
import styles from './Badge.module.css.js';

const Badge = ({ children, colorPair, size = 'sm', className, ...props }) => {
    const badgeStyles = clsx(styles.badge, styles[size], className);
    return (jsxRuntimeExports.jsx(Base, { "aria-hidden": "true", className: badgeStyles, style: { ...colorPair }, ...props, children: children }));
};
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=Badge.js.map
